import axios from 'axios';
import config from '../config';

export async function loginHelper(u, p) {
  if (u === '' || p === '') return false;

  const loginData = new FormData();
  loginData.append('username', u);
  loginData.append('password', p);

  try {
    const output = await axios.post(config.LOGIN_API, loginData);
    if (output.data.response.status === 'OK') {
      return output.data.response.token;
    } else {
      return false;
    }
  } catch (error) {
    console.log(error);
  }
}

export async function changePasswordHelper(cp, p1, p2) {
  if (cp !== '' && p1 !== '' && p2 !== '') {
    if (p1 === p2) {
      const data = new FormData();
      data.append('mode', 'changePassword');
      data.append('cp', cp);
      data.append('p1', p1);
      data.append('p2', p2);
      data.append('auth', localStorage.getItem('token'));

      try {
        const output = await axios.post(config.LOGIN_API, data);
        return output.data.response.status;
      } catch (error) {
        console.log(error);
      }
    } else {
      return 'Your new passwords do not match';
    }
  } else {
    return 'Please make sure all fields are filled before submission';
  }
}
